import { createContext, useContext } from "react";
import Cookie from 'js-cookie'
import { USER_ID_KEY } from "./constants";
export const initialState = {
    setState: (_name: string, _value: any) => { },
    loading: false,
    currentUserId: Cookie.get(USER_ID_KEY),
    currentUser: null as UserRecord | null,
    deviceMapDataSourceRefreshKey: Symbol(),
    currentProjectDetail: null as Project | null,
};

export const AppContext = createContext(initialState);

export const useApp = () => {
    const app = useContext(AppContext)
    return {
        ...app,
        setState: (name: keyof typeof initialState, value: any) => {
            app.setState(name, value)
        }
    }
};